export const STORAGE_KEYS = {
  localTemplates: 'persist:allPendingTemplates',
  refreshToken: 'refreshToken',
  token: 'token',
} as const;
